module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgements#Ack"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction#Intr"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_c('b', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ITCHES")]), _vm._v(", W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IZARDS AND")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMPIRES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-1"
    }
  }, [_vm._v("Tessa")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-2"
    }
  }, [_vm._v("Moll Pitcher ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-3"
    }
  }, [_vm._v("The Magician of Marblehead ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-4"
    }
  }, [_vm._v("Goody Cole ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-5"
    }
  }, [_vm._v("Tammy Younger ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-6"
    }
  }, [_vm._v("Foster, Rhode Island: A Real Witch City ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-7"
    }
  }, [_vm._v("Exeter, Rhode Island: The “Last” Vampire ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-8"
    }
  }, [_vm._v("JB 55 ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-9"
    }
  }, [_vm._v("Mary Nasson ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-10"
    }
  }, [_vm._v("Cumberland’s Strange Request ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-11"
    }
  }, [_vm._v("Dogtown’s Easter Carter ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1-12"
    }
  }, [_vm._v("Molly Bridget ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URSES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aunt Lonnie Davis ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hayden Family Curse ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Curse of Micah Rood’s Apples ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rachel’s Curse ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonathan Moulton Could Not Fool the Devil ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAVE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCERNS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Macabre Monument Marks the Spot of a Gruesome Murder ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucas Douglass ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warren Gibbs ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hillers’ Monumental Monument ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strange Premonition of Francis Lightfoot Eddy ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John P. Bowman’s Eternal Pose ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. Timothy Clark Smith ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asa “Popcorn” Snow ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Confederate Buried in a Yankee Cemetery ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deacon Wheelock’s Protected Grave ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caroline Cutter ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persecuted for Wearing a Beard ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strange Burial in Damariscotta, Maine ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Samuel Jones ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XYZ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIQUE")]), _vm._v(" Y"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANKEE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EGENDS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Handkerchief Moody")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lord Timothy Dexter ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Vermonters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Melon Heads of Connecticut ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen Alive ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Green People of Coventry ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phineas Gage ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helen Dow Peck’s Amazing Will ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Did Ephriam Gray Go?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AGABONDS AND")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDERERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Darn Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Coot of Mount Greylock ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leather Man ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cling Clang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARED")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REAT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HINGS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Hays Hammond Jr. ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Miller ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ghost of the White Bird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hiram Marble ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dr. Thomas Benton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D.D. Home ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Captain Thunderbolt ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Lucrezia Borgia of Ansonia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROM")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EYOND THE")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAVE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vengeful Ghost of Rebecca Cornell ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Parrot Once Helped Solve a Triple Murder ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seer of Rutland ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nelly Butler: First Lady of American Ghosts ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Madame Sherri’s Staircase")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wareham’s Haunted Violin ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gardner Lake’s Ghostly Piano")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Bibliography#Bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Author#Aut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0